export class EntityManager {

    entities = {}

    reset() {
        this.entities = {}
    }

    addEntity(e) {
        // console.log("EntityManager::addEntity", e)
        this.entities[e.getID()] = e
    }

    removeEntity(uid) {
        // console.log("EntityManager::removeEntity", uid)
        delete this.entities[uid]
    }

    /**
     * Update & override keys on the entity from data update
     * @param uid
     * @param data
     * @param animation
     */
    updateEntity(uid, data, animation = null) {
        const e = this.get(uid)
        if (!e) {
            console.error("EntityManager::updateEntity", uid, "not found")
            return
        }
        // console.log("Updating entity", e, data)

        const dataKeys = Object.keys(data)
        for (let key in dataKeys) {
            // console.log("EntityManager::updateEntity", uid, key, dataKeys[key], data[dataKeys[key]])
            this.entities[uid][dataKeys[key]] = data[dataKeys[key]]
        }

        if (animation !== null) {
            if (animation === "walk" || animation === "run")
                return; //TODO stops the jump animation from fucking up

            this.entities[uid].playAnimation(animation)
        }

        // this.entities[uid] = Object.assign({}, e, data);
    }

    all() {
        return this.entities
    }

    get(uid) {
        return this.entities[uid]
    }

    inArea(xmin, xmax, ymin, ymax) {
        return this.entities.map(e => e.getPosition()).filter(p => p.x >= xmin && p.x <= xmax && p.y >= ymin && p.y <= ymax)
    }

    getEntitiesOfType(typ) {
        var ents = {}
        for (let e in this.entities) {
            if (e.getType() === typ) {
                ents[e.uid] = e
            }
        }
        return ents;
    }

    /**
     * Main animation loop
     * @param delta
     */
    animate(delta) {
        for (let e in this.entities) {
            this.entities[e].animate(delta)
        }
    }
}